import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 7.949C16 3.559 12.418 0 8 0S0 3.559 0 7.949s3.582 7.949 8 7.949 8-3.559 8-7.949Zm-7.99 5.96a.049.049 0 0 1-.02 0 .216.216 0 0 1-.039-.012.855.855 0 0 1-.216-.14c-.216-.182-.496-.522-.775-1.076-.46-.915-.815-2.214-.925-3.738h3.93c-.11 1.524-.465 2.823-.925 3.738-.279.554-.56.894-.775 1.075a.855.855 0 0 1-.216.141.216.216 0 0 1-.038.012Zm1.955-6.954h-3.93c.11-1.524.465-2.823.925-3.738.279-.554.56-.894.775-1.075A.853.853 0 0 1 7.95 2 .215.215 0 0 1 8 1.987l.01.002A.215.215 0 0 1 8.05 2c.04.016.113.054.216.14.216.182.496.522.775 1.076.46.915.815 2.214.925 3.738Zm2.004 1.988c-.098 1.566-.426 2.992-.914 4.138a5.967 5.967 0 0 0 2.862-4.138h-1.948Zm1.948-1.988h-1.948c-.098-1.567-.426-2.992-.914-4.138a5.967 5.967 0 0 1 2.862 4.138Zm-9.886 0c.098-1.567.426-2.992.914-4.138a5.967 5.967 0 0 0-2.862 4.138h1.948ZM2.083 8.943a5.967 5.967 0 0 0 2.862 4.138c-.488-1.146-.816-2.572-.914-4.138H2.083Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureInternet16 = createIcon(IconComponent);